module.exports = __webpack_public_path__ + "static/media/icon-money-light.dc1af759.svg";